/**
 * VehicleWheel3D property surface. A field stays `undefined` when unauthored: the
 * consumer (inspector, gizmo) applies Godot's default, so "authored the default"
 * and "authored nothing" stay distinct. They are simulation inputs (ADR-0005), and
 * they are parsed because they describe the wheel's geometry.
 */
/**
 * Godot 4.6 VehicleWheel3D defaults (doc/classes/VehicleWheel3D.xml), shared by
 * the inspector formatter and the gizmo so a corrected default reaches both.
 */
export const VEHICLE_WHEEL_3D_DEFAULTS = {
    wheel_radius: 0.5,
    wheel_rest_length: 0.15,
    wheel_friction_slip: 10.5,
    wheel_roll_influence: 0.1,
    suspension_stiffness: 5.88,
    suspension_travel: 0.2,
    suspension_max_force: 6000,
    damping_compression: 0.83,
    damping_relaxation: 0.88,
    use_as_traction: false,
    use_as_steering: false,
};
//# sourceMappingURL=types.js.map